// src/factory.ts
var TRANSFORMS = {};
var PARSERS = {};
var getParser = (type) => PARSERS[type];
var registerParser = (type, parserFunction) => {
  PARSERS[type] = parserFunction;
};
var getTransform = (type) => TRANSFORMS[type];
var registerTransform = (type, transFunction) => {
  TRANSFORMS[type] = transFunction;
};
export {
  getParser,
  getTransform,
  registerParser,
  registerTransform
};
